import apiClient from './authService';

export const documentService = {
  async getDocuments(params = {}) {
    try {
      const response = await apiClient.get('/documents', { params });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to fetch documents');
    }
  },

  async getDocument(id) {
    try {
      const response = await apiClient.get(`/documents/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to fetch document');
    }
  },

  async uploadDocument(formData) {
    try {
      const response = await apiClient.post('/documents', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to upload document');
    }
  },

  async updateDocumentStatus(id, status) {
    try {
      const response = await apiClient.patch(`/documents/${id}/status`, { status });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to update document status');
    }
  },

  async downloadQRCode(id, format = 'png') {
    try {
      const response = await apiClient.get(`/documents/${id}/qr?format=${format}`, {
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to download QR code');
    }
  },

  async deleteDocument(id) {
    try {
      const response = await apiClient.delete(`/admin/documents/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to delete document');
    }
  },
};